import FormValidator from '@videotools/js/form/form-validator';

export default {
	data() {
		return {
			formErrors:    {},
			formValidator: null,
		};
	},
	computed: {
		hasFormErrors() {
			for (const field in this.formErrors) {
				if (this.formErrors[field]) {
					return true;
				}
			}
			return false;
		},
	},
	methods: {
		initValidator(validators, initialValues) {
			this.formValidator = new FormValidator(validators, initialValues);
		},
		validateField(fieldName, value) {
			const fieldErr = this.formValidator
				.setValue(fieldName, value)
				.validateField(fieldName)
				.getError(fieldName);

			this.formErrors = { ...this.formErrors, [fieldName]: fieldErr };
		},
	},
};
